module.exports = __webpack_public_path__ + "static/media/m_w_hr_18.6e4d0256.png";